import { useCredits } from "../contexts/CreditContext";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ShoppingCart } from "lucide-react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";

/**
 * Modal shown when a user has exhausted their AI credits.
 * Offers: Upgrade Plan → Buy Credits → Wait for Reset
 */
export default function UpgradeModal() {
  const ctx = useCredits();
  const navigate = useNavigate();
  if (!ctx) return null;

  const { showUpgradeModal, setShowUpgradeModal, plan, resetDate } = ctx;

  const resetStr = resetDate
    ? new Date(resetDate).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      })
    : null;

  return (
    <Dialog open={showUpgradeModal} onOpenChange={setShowUpgradeModal}>
      <DialogContent className="sm:max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <Sparkles className="w-6 h-6 text-destructive" />
          </div>
          <DialogTitle className="text-center">AI Credits Exhausted</DialogTitle>
          <DialogDescription className="text-center">
            You've used all your AI credits for this cycle.
            {resetStr && (
              <>
                {" "}
                Credits reset on <span className="font-medium text-foreground">{resetStr}</span>.
              </>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 pt-2">
          {plan !== "power" && (
            <Button
              className="w-full"
              onClick={() => {
                setShowUpgradeModal(false);
                navigate("/pricing");
              }}
              data-testid="upgrade-modal-cta"
            >
              Upgrade Plan
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          )}
          <Button
            variant="secondary"
            className="w-full"
            onClick={() => {
              setShowUpgradeModal(false);
              navigate("/buy-credits");
            }}
            data-testid="upgrade-modal-buy-credits"
          >
            <ShoppingCart className="w-4 h-4 mr-2" />
            Buy Credits
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => setShowUpgradeModal(false)}
            data-testid="upgrade-modal-dismiss"
          >
            {resetStr ? `Wait until ${resetStr}` : "Close"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
